module.exports = __webpack_public_path__ + "img/ic_vtv.a3b136f0.png";